// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__EPLMs","total":"AdvancePaymentDetails_total__8Bj1i","edit":"AdvancePaymentDetails_edit__V5mzd"};